import { Component } from '@verndale/core';
import { gsap, Expo } from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import { debounce } from '../helpers';

gsap.registerPlugin(ScrollTrigger);

class Module extends Component {
  setupDefaults() {
    this.breakpoint = matchMedia('(max-width: 740px)');

    this.dom = {
      heroSidebar: document.querySelector('.generic-hero__sidebar-inner'),
      inner: this.el.querySelector('.generic-content__inner'),
      decorator: this.el.querySelector('.generic-content__decorator img'),
      supportingCard: document.querySelector(
        '.generic-content__supporting-card'
      ),
      supportingCardContent: document.querySelector(
        '.generic-content__supporting-card-content'
      )
    };

    this.checkContentHeight();

    if (this.dom.supportingCard) {
      this.showMoreLabel = this.dom.supportingCard.dataset.showMoreLabel;
      this.showLessLabel = this.dom.supportingCard.dataset.showLessLabel;

      this.dom.button = document.createElement('button');
      this.dom.button.classList = 'btn-v2 btn--primary';
      this.dom.button.innerHTML = `<div class='btn-content'><span>${  this.showMoreLabel  }</span><svg viewBox='0 0 60 60' class='primary'><use xlink:href='#show-more-icon-rebrand'></use></svg>`;

      this.checkCollapseText();
    }

    if (this.dom.decorator) {
      this.initShapeAnimation();
    }
  }

  addListeners() {
    window.addEventListener(
      'resize',
      debounce(this.checkContentHeight.bind(this), 300)
    );

    if (this.dom.supportingCard) {
      window.addEventListener(
        'resize',
        debounce(this.checkCollapseText.bind(this), 300)
      );
      this.dom.button.addEventListener(
        'click',
        this.handleShowMoreLess.bind(this)
      );
    }
  }

  initShapeAnimation() {
    let rotation = 0,
      scale = 0.55;

    if (
      this.dom.decorator.classList.contains(
        'generic-content__decorator--sphere'
      )
    ) {
      rotation = -20;
      scale = 0.65;
    }

    gsap.from(this.dom.decorator, {
      scrollTrigger: {
        trigger: this.el,
        end: 'center 25%',
        scrub: true
      },
      opacity: 0,
      scale,
      rotation
    });
  }

  checkCollapseText() {
    if (this.breakpoint.matches) {
      if (
        this.dom.supportingCardContent.offsetHeight <
        this.dom.supportingCardContent.scrollHeight
      ) {
        this.dom.supportingCardContent.classList.add(
          'generic-content__supporting-card--overflow'
        );
        this.dom.supportingCard.append(this.dom.button);
      } else {
        this.dom.supportingCardContent.classList.remove(
          'generic-content__supporting-card--overflow'
        );
        this.dom.button.remove();
      }
    } else {
      this.dom.supportingCardContent.style.height = null;
      this.dom.supportingCardContent.classList.remove(
        'generic-content__supporting-card--overflow'
      );
      this.dom.supportingCardContent.classList.remove(
        'generic-content__supporting-card-content--expanded'
      );
      this.dom.button.remove();
    }
  }

  checkContentHeight() {
    if (!this.breakpoint.matches && this.dom.heroSidebar) {
      this.dom.inner.style['min-height'] = `${
        this.dom.heroSidebar.offsetHeight - 200
      }px`;
    } else {
      this.dom.inner.style['min-height'] = null;
    }
  }

  handleShowMoreLess(e) {
    e.stopPropagation();

    if (
      this.dom.supportingCardContent.classList.contains(
        'generic-content__supporting-card-content--expanded'
      )
    ) {
      this.collapse();
      this.dom.button.innerHTML = `<div class='btn-content'><span>${  this.showMoreLabel  }</span><svg viewBox='0 0 60 60' class='primary'><use xlink:href='#show-more-icon-rebrand'></use></svg>`;

    } else {
      this.expand();
      this.dom.button.innerHTML = `<div class='btn-content'><span>${  this.showLessLabel  }</span><svg viewBox='0 0 60 60' class='primary'><use xlink:href='#minus-icon-rebrand'></use></svg>`;
    }
  }

  expand() {
    this.textHeight = this.dom.supportingCardContent.offsetHeight;
    this.dom.supportingCardContent.classList.add(
      'generic-content__supporting-card-content--expanded'
    );
    gsap.set(this.dom.supportingCardContent, { height: 'auto' });
    gsap.from(this.dom.supportingCardContent, {
      height: this.textHeight,
      ease: Expo['easeOut'],
      duration: 0.4,
      onComplete: () => {
        this.dom.supportingCardContent.style.height = null;
        this.dom.supportingCardContent.classList.remove(
          'generic-content__supporting-card--overflow'
        );
      }
    });
  }

  collapse() {
    this.dom.supportingCardContent.classList.add(
      'generic-content__supporting-card--overflow'
    );
    gsap.set(this.dom.supportingCardContent, {
      height: this.dom.supportingCardContent.offsetHeight
    });
    gsap.to(this.dom.supportingCardContent, {
      height: this.textHeight,
      ease: Expo['easeOut'],
      duration: 0.4,
      onComplete: () => {
        this.dom.supportingCardContent.classList.remove(
          'generic-content__supporting-card-content--expanded'
        );
        this.dom.supportingCardContent.style.height = null;
      }
    });
  }
}

export default Module;
